import React from 'react'
import style from './startsoon.module.css'

function Physicsbyshyam() {
  return (
    <div  className = {style.start_soon}>
      <img src='https://edge.uacdn.net/static/thumbnail/course/1E84AD7C-2E49-4A71-9303-5AC47EA86A80_plus.png?q=100&w=512' alt='_Sumit_img' />
      <div>
        <p>HINDI    UPSC NDA</p>
        <h4>Crash Course on Physics and Biology</h4> 
        <p>Starts on Mar 10, 2022 • 21 lessons</p> 
        <p>Shyam Sharma</p>  
      </div>
    </div>        
  )
}
export default Physicsbyshyam;